import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { GetSuppliers } from './thunks';
import { GetSuppliersReducer, ResetSuppliersStateReducer } from './reducers';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'suppliers',
  initialState,
  reducers: {
    ResetSuppliersState: ResetSuppliersStateReducer,
  },
  extraReducers: (builder) => {
    // GetSuppliers
    addExtraReducer(builder, GetSuppliers, GetSuppliersReducer);
  },
});

export default slice.reducer;
